export default __webpack_public_path__ + "static/media/publicSADMSLogo.71fd6568.svg";